export default (urlParameters) => {
  return {
    first_time_user: false,
    member_level: 49,
    member_level_name: 'Guest',
    messages: '[]',
    non_trial_member_level: 49,
    non_trial_member_level_name: 'Guest',
    show_ads: 'true',
    show_ads_toggle: false,
    show_nc_wind_toggle: true,
    user_signed_in: false,
    user_tips: [1, 2],
    wf_username: 'jshoreman',
    // messages: '[{"Actions":[{"Label":"$20 off Pro","Type":"2"},{"Label":"No thanks","Type":"-1"}],"Expire_Time":"2024-5-30 13:0:00","Id":1711736276,"Message":"Like our PRO and PLUS features? Grab your discount!  \u003ca href=\u0027https://secure.sailflow.com/signup.iws?level=pro\u0026plan=Annual_Plan\u0026referrerID=434023\u0026wf_token=6bfa648e4b1dad5c9857a34625fc8edc\u0027\u003e$20 off PRO\u003c/a\u003e or \u003ca href=\u0027https://secure.sailflow.com/signup.iws?level=plus\u0026plan=Annual_Plan\u0026referrerID=434023\u0026wf_token=6bfa648e4b1dad5c9857a34625fc8edc\u0027\u003e$10 off PLUS\u003c/a\u003e","Title":"Membership Free Trial","Type":404,"Type_Str":"PERIOD_5_POST_EVENT_B"}]',
    settings: {
      units_wind: 'mph',
      units_temp: 'f',
      units_distance: 'mi',
      units_precip: 'in'
    }
  }
}
